var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-213 -393) translate(80 378) translate(133 14) translate(0 1) translate(0 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 1,
    x: 0.5,
    y: 15.417,
    stroke: "#FFF",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M8.629 11.999c.101 0 .2-.02.293-.059.094-.04.195-.11.305-.211l3.785-3.68c.164-.164.246-.347.246-.55 0-.211-.072-.383-.217-.516-.145-.133-.322-.2-.533-.2-.227 0-.414.083-.563.247l-1.734 1.84-.832.855.07-1.64V.797C9.45.586 9.37.4 9.21.24 9.049.08 8.855 0 8.629 0c-.227 0-.418.08-.574.24-.157.16-.235.346-.235.557v7.288l.059 1.652-.82-.867L5.3 7.03c-.14-.164-.328-.246-.563-.246-.21 0-.386.066-.527.199-.14.133-.211.305-.211.516 0 .203.078.386.234.55l3.797 3.68c.11.102.211.172.305.211.094.039.191.059.293.059z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownloadWhite);
export default __webpack_public_path__ + "static/media/ic_download_white.c6ae2fc2bb8267057a76a988fbd7fd32.svg";
export { ForwardRef as ReactComponent };